// extracted by mini-css-extract-plugin
module.exports = {"sectionRow":"vKmv21IB","titleBase":"TfIoxejs","styledRankWrapper":"bKw2Bkcf","rankContainer":"XPJqrdD8","rankLabel":"uyIpBvKz","rankFlexRow":"mNdOGsE5"};